import React, { useCallback, useEffect, useState } from 'react';
import { Modal, ModalBody, Row } from 'reactstrap';
import { useLocation } from 'react-router';

import Loader from 'components/Loader';
import { useRecordTypesByUser } from 'views/RecordType/hooks/useRecordTypesByUser';
import RecordTypeSelection from 'views/RecordType/components/RecordTypeSelection';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import ContactInputs from 'views/CRM/Contact/form/FormInputs';

function AddContactModal({
  buttonOpenModal,
  protocolTelephoneNumber,
  contact = null,
  defaultFieldsAutoComplete,
  setSelectedContact
}) {
  const [selectedRecordTypeId, setSelectedRecordTypeId] = useState(null);
  const [shouldShowContacts, setShouldShowContacts] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { state } = useLocation();

  const { recordTypes, isLoadingRecordTypes, getRecordTypesByUser } =
    useRecordTypesByUser(entitiesName.CONTACT);

  useEffect(() => {
    getRecordTypesByUser();
  }, [getRecordTypesByUser]);

  useEffect(() => {
    if (recordTypes && recordTypes.length === 1) {
      setSelectedRecordTypeId(recordTypes[0].id);
      setShouldShowContacts(true);
    }
  }, [recordTypes]);

  /**
   * Quando a rota é chamada e deve-se abrir diretamente a listagem, sem
   * selecionar manualmente o tipo de registro.
   */
  useEffect(() => {
    if (state && state.recordTypeId) {
      setSelectedRecordTypeId(state.recordTypeId);
      setShouldShowContacts(true);
    }
  }, [state]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedRecordTypeId(null);
      setShouldShowContacts(false);
    }
  }, [isOpen]);

  const shouldShowRecordTypeSelection = useCallback(() => {
    return isOpen && (isLoadingRecordTypes || !shouldShowContacts);
  }, [isOpen, isLoadingRecordTypes, shouldShowContacts]);

  const handleOnSelectedRecordType = useCallback((recordTypeId) => {
    setSelectedRecordTypeId(recordTypeId);
    setShouldShowContacts(true);
  }, []);

  const renderWithBaseLayout = (children) => {
    return (
      <>
        {buttonOpenModal({
          onClick: () => setIsOpen(!isOpen)
        })}
        <Modal
          className="modal-dialog-centered"
          isOpen={isOpen}
          returnFocusAfterClose={false}
          unmountOnClose={true}
          size="lg"
        >
          {children && (
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-default">
                Criar novo contato
              </h6>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              >
                <span aria-hidden={true}>&times;</span>
              </button>
            </div>
          )}
          {children}
        </Modal>
      </>
    );
  };

  const render = () => {
    if (!recordTypes || !recordTypes.length)
      return renderWithBaseLayout(
        <Row className="justify-content-md-center">
          <Loader />
        </Row>
      );

    if (shouldShowRecordTypeSelection()) {
      return renderWithBaseLayout(
        <ModalBody>
          <RecordTypeSelection
            recordTypes={recordTypes}
            handleOnSelectedRecordType={handleOnSelectedRecordType}
          />
        </ModalBody>
      );
    }

    if (!isOpen) return renderWithBaseLayout(null);

    return renderWithBaseLayout(
      <ModalBody>
        <ContactInputs
          key={selectedRecordTypeId}
          protocolTelephoneNumber={protocolTelephoneNumber || ''}
          recordTypeId={selectedRecordTypeId}
          contact={contact}
          defaultFieldsAutoComplete={defaultFieldsAutoComplete}
          onCancelAction={() => setIsOpen(false)}
          onSaveAction={(contactData) => {
            if (setSelectedContact && contactData) {
              const { id, name, phone, email } = contactData;
              setSelectedContact({
                clientId: id,
                clientName: name,
                clientPhone: phone,
                clientEmail: email
              });
            }
            setIsOpen(false);
          }}
          formId="addContactModalForm"
        />
      </ModalBody>
    );
  };

  return render();
}

export default AddContactModal;
